import { Link as RouterLink } from 'react-router-dom';
import { Button, type ButtonProps } from '@/ui';

type Props = ButtonProps & {
  to: string;
};

export const Link = ({ to, ...props }: Props): JSX.Element => {
  return (
    <Button
      as={RouterLink}
      fontWeight="normal"
      to={to}
      variant="link"
      {...props}
    />
  );
};
